module.exports = __webpack_public_path__ + "static/media/watern32_1.38fe297c.png";